import React, { useEffect, useState } from "react";
import Head from "../../../layout/head/Head";
import Content from "../../../layout/content/Content";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Col,
  Icon,
  PreviewAltCard,
  Row,
} from "../../../components/Component";
import { set, useForm } from "react-hook-form";
import { Badge, Form, Label, Spinner, Tooltip } from "reactstrap";
import Required from "../../../myComponents/validate/Required";
import Select from "react-select";
import Status from "../../../myComponents/form/Status";
import MyButton from "../../../myComponents/form/MyButton";
import {
  bulkImportQuestionAPI,
  createQuestionAPI,
  deleteQuestionAPI,
  generateQuestionWithAIApi,
  getChapterBySubjectAndClassDD,
  getClassDD,
  getQuestionAPI,
  getStreamByClassDD,
  getSubjectByClassDD,
  getSubjectByClassLMSDD,
  updateQuestionAPI,
  updateQuestionStatusAPI,
} from "../../../api/LMS/master";
import { toast } from "react-toastify";
import MyDataTable from "../../../myComponents/DataTable/MyDataTable";
import ConfirmModal from "../../../myComponents/modals/ConfirmModal";
import { decrypt, encrypt } from "../../../utils/Encrypt";
import { DeleteModal } from "../../../myComponents/modals/DeleteModal";
import useLogout from "../../../hooks/useLogout";
import { hasPermission, validateExcel, validateExcelOrCsv } from "../../../utils/myFunctions";
import { BASE_URL_IMG_LMS, questionsList, textQ } from "../../../assets/constants/constants";
import QuestionModal from "../../../myComponents/modals/QuestionModal";
import { ExportQuestion } from "../../../myComponents/export/ExportQuestion";
import { useLocation, useNavigate } from "react-router";

const Question = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [mode, setMode] = useState("Add");
  const [isLoading, setIsLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [classList, setClassList] = useState([]);
  const [subjectList, setSubjectList] = useState([]);
  const [chapterList, setChapterList] = useState([]);
  const [importQ, setImportQ] = useState(false);
  const [importAI, setImportAI] = useState(false);
  const [toolImage, setToolImage] = useState(false);
  //Question Modal
  const [qModal, setQModal] = useState(false);
  const toggleQModal = () => {
    setQModal(!qModal);
  };
  const toggleImage = () => {
    setToolImage(!toolImage);
  };
  const location = useLocation();
  const navigate = useNavigate();
  const enc = JSON.parse(localStorage.getItem("userDetail"));
  const user = decrypt(enc?.data || []);
  const isView = hasPermission(user, location?.pathname, "isView");
  const isUpdate = hasPermission(user, location?.pathname, "isUpdate");
  const isDelete = hasPermission(user, location?.pathname, "isDelete");
  const isCreate = hasPermission(user, location?.pathname, "isCreate");
  const [timer, setTimer] = useState(5); // 5 seconds countdown
  useEffect(() => {
    if (!isView) {
      const interval = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
      // redirect to home page when the timer reaches 0
      if (timer === 0) {
        navigate(-1);
      }
      // clean up the interval when the component unmounts
      return () => clearInterval(interval);
    } else {
      setIsLoading(false);
    }
  }, [timer]);
  const logout = useLogout();
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,
    setError,
    clearErrors,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      status: null,
      streamList: [],
      mode: "Add",
      sampleFile1: null,
      sampleFile2: null,
      file: null,
    },
  });
  const[sampleFile1, setSampleFile1] = useState(null)
  const[sampleFile2, setSampleFile2] = useState(null)
  const [data, setData] = useState([
    // {
    //   question_type: "multiple_choice",
    //   answers: [
    //     { answer_text: "Option A", is_correct: true },
    //     { answer_text: "Option B", is_correct: true },
    //     { answer_text: "Option C", is_correct: false },
    //     { answer_text: "Option D", is_correct: false },
    //   ],
    // },
  ]);
  const optionColumns1 = Array.from({ length: 4 }, (_, index) => ({
    name: `Option ${index + 1}`,
    selector: (row) => row.answers?.[index]?.answer_text || "",
    wrap: true,
    cell: (row) => {
      const isValid = (row.question_type === "true_false" && index < 2) || row.question_type === "single_choice";

      if (!isValid) return null;

      const answer = row.answers?.[index];
      if (!answer) return null;

      return (
        <div className="d-flex align-items-center my-2">
          <Icon
            name={answer.is_correct ? "check" : "cross"}
            className={`me-1 ${answer.is_correct ? "text-success" : "text-danger"}`}
          />
          {answer.answer_text}
        </div>
      );
    },
  }));
  const optionColumns = Array.from({ length: 4 }, (_, index) => ({
    name: `Option ${index + 1}`,
    selector: (row) => row.answers?.[index]?.answer_text || "",
    wrap: true,
    cell: (row) => {
      const { question_type, answers } = row;

      const isValid =
        (question_type === "true_false" && index < 2) ||
        question_type === "single_choice" ||
        question_type === "multiple_choice";

      if (!isValid) return null;

      const answer = answers?.[index];
      if (!answer) return null;

      return (
        <div className="d-flex align-items-center my-2">
          <Icon
            name={answer.is_correct ? "check" : "cross"}
            className={`me-1 ${answer.is_correct ? "text-success" : "text-danger"}`}
          />
          {answer.answer_text}
        </div>
      );
    },
  }));

  const [columns, setColumns] = useState([
    {
      name: "Class",
      selector: (row) => (
        <div className="my-3">
          <span className="">{row.class_name}</span>
        </div>
      ),
      wrap: true,
    },
    {
      name: "Stream",
      selector: (row) => row?.stream,
      sortable: true,
      wrap: true,
    },
    {
      name: "Subject",
      selector: (row) => (
        <div className="my-3">
          <span className="">{row.subject_name}</span>
        </div>
      ),
      wrap: true,
    },
    {
      name: "Chapter",
      selector: (row) => (
        <div className="my-3">
          <span className="">{row.chapter_name}</span>
        </div>
      ),
      wrap: true,
    },
    {
      name: "Question Type",
      selector: (row) => (
        <div className="my-3">
          {row?.question_type == "single_choice" && <span className="">{"Single Choice"}</span>}
          {row?.question_type == "true_false" && <span className="">{"True or False"}</span>}
        </div>
      ),
      wrap: true,
    },
    {
      name: "Question",
      selector: (row) => (
        <div className="my-3">
          <span className="">{row.question_text}</span>
        </div>
      ),
      wrap: true,
    },

    ...optionColumns,
    {
      name: "Status",
      selector: (row) => row?.status,
      cell: (row) => (
        <div style={{ cursor: "pointer" }} onClick={() => handleToggleStatus(row)}>
          <Badge color={`${row.status == "active" ? "success" : "danger"}`}>
            {row.status == "active" ? "Active" : "Inactive"}
          </Badge>
        </div>
      ),
      sortable: true,
      wrap: true,
    },
    {
      name: "Action",
      cell: (row) => (
        <div>
          {isUpdate && (
            <Button outline color={`warning`} size={`xs`} className={`me-1`} onClick={() => handleEdit(row)}>
              {" "}
              <Icon name="edit" />
            </Button>
          )}
          {isDelete && (
            <Button outline color={`danger`} size={`xs`} onClick={() => handleDelete(row)}>
              <Icon name="trash"></Icon>
            </Button>
          )}
        </div>
      ),
    },
  ]);
  const handleToggleStatus = (row) => {
    setSelectedRow(row);
    setShowModal(true);
  };
  useEffect(() => {
    if (user?.role == "Subject Specialist") {
      const body = {
        value: user?.class_id,
      };
      handleClassChange(body);
      const body1 = {
        value: user?.stream_id,
      };
      handleStreamChange(body1);
      const body2 = {
        value: user?.subject_id,
      };
      handleSubjectChange(body2);
    } else {
      getClass();
    }
    getQuestion();
  }, []);
  const getQuestion = () => {
    const data = {};
    setIsLoading(true);
    getQuestionAPI(data)
      .then((res) => {
        // decrypt data
        const status = res.data.status;
        // const status = decrypt(res.data.status);
        if (status === true) {
          // const decryptedResponse = decrypt(res.data.data.tableData);
          setData(res.data.data.question_list);
          setValue("sampleFile1", res.data.data.sample_file_single_choice);
          setSampleFile1(res.data.data.sample_file_single_choice);
          setValue("sampleFile2", res.data.data.sample_file_true_or_false_choice);
          setSampleFile2(res.data.data.sample_file_true_or_false_choice);
          toast.clearWaitingQueue();
          setIsLoading(false);
        } else if (status === false) {
          setIsLoading(false);
          toast.clearWaitingQueue();
          setData([]);
        } else if (status === "expired") {
          toast.error(res.data.message);
          logout();
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };
  const getClass = () => {
    const data = {};
    getClassDD(data)
      .then((res) => {
        // decrypt data
        const status = res.data.status;
        // const status = decrypt(res.data.status);
        if (status === true) {
          // const decryptedResponse = decrypt(res.data.data.tableData);
          setClassList(res.data.data);
          toast.clearWaitingQueue();
        } else if (status === false) {
          toast.clearWaitingQueue();
          setClassList([]);
        } else if (status === "expired") {
          toast.error(res.data.message);
          logout();
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };
  const handleClassChange = (selectedOption) => {
    setValue("class", selectedOption || "");
    trigger("class");
    if (watch("mode") == "Add") {
      setValue("stream", "");
      setValue("subject", "");
      // trigger("subject");
      setValue("chapter", "");
      // trigger("chapter");
      setSubjectList([]);
      setChapterList([]);
    }
    const body = {
      class_id: selectedOption?.value,
    };
    if (selectedOption?.value == "1") {
      getSubjectByClass(body);
    }
    if (selectedOption?.value == "2" || selectedOption?.value == "3") {
      const data = {
        class_id: selectedOption?.value,
      };
      getStreamByClass(data);
    }
  };
  const getSubjectByClass = (body) => {
    getSubjectByClassLMSDD(body)
      .then((res) => {
        const status = res.data.status;
        if (status === true) {
          setSubjectList(res.data.data);
        } else if (status === false) {
          setSubjectList([]);
        } else if (status === "expired") {
          setSubjectList([]);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => {
        console.log("Err", err);
      });
  };
  const handleSubjectChange = (selectedOption) => {
    setValue("subject", selectedOption || "");
    trigger("subject");
    if (watch("mode") == "Add") {
      setValue("chapter", "");
      // trigger("chapter");
    }
    setChapterList([]);
    const body = {
      class_id: watch("class")?.value,
      subject_id: selectedOption?.value,
    };
    getChapterBySubject(body);
  };

  const getChapterBySubject = (body) => {
    getChapterBySubjectAndClassDD(body)
      .then((res) => {
        const status = res.data.status;
        if (status === true) {
          setChapterList(res.data.data);
        } else if (status === false) {
          setChapterList([]);
        } else if (status === "expired") {
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => {
        console.log("Err", err);
      });
  };
  const handleChapterChange = (selectedOption) => {
    setValue("chapter", selectedOption || "");
    trigger("chapter");
  };
  const handleQuestionTypeChange = (selectedOption) => {
    setValue("question_type", selectedOption || "");
    trigger("question_type");
  };
  const handleDelete = (row) => {
    setValue("deleteQuestion", row?.question_text);
    setValue("deleteRow", row);
    setShowDelete(true);
    return;
  };
  const handleEdit = (row) => {
    window.scrollTo(0, 0);
    console.log(row, "rowEdit");

    setIsOpen(true);
    setMode("Edit");
    setValue(("mode", "Edit"));
    trigger("mode");
    setValue("question", row?.question_text);
    setValue("id", row?.id);
    setValue("chapter", {
      value: row?.chapter_id,
      label: row?.chapter_name,
    });

    setValue("stream", { value: row?.stream_id, label: row?.stream });

    setValue("class", {
      value: row?.class_id,
      label: row?.class_name,
    });
    setValue("subject", {
      value: row?.subject_id,
      label: row?.subject_name,
    });
    setValue("status", {
      label: row.status == "active" ? "Active" : "Inactive",
      value: row?.status,
    });
    setValue("question_type", {
      label:
        row.question_type == "true_false"
          ? "True or False"
          : row?.question_type == "single_choice"
            ? "Single Choice"
            : row?.question_type == "multi_choice"
              ? "Multiple Choice"
              : null,
      value: row.question_type,
    });
    setValue("rowUpdate", row);
    const optionKeys = ["option_one", "option_two", "option_three", "option_four"];
    const options = row.answers;

    if (options) {
      const correctOptions = [];

      options.forEach((opt, index) => {
        const key = optionKeys[index];
        setValue(key, opt.answer_text);
        if (opt.is_correct) {
          correctOptions.push(key);
        }
      });

      if (row.question_type === "multiple_choice") {
        setValue("correctOption", correctOptions); // ✅ array
      } else {
        setValue("correctOption", correctOptions[0] || ""); // ✅ single value
      }
    }

    const body = {
      class_id: row.class_id,
    };
    const payload = {
      subject_id: row.subject_id,
    };
    if (row?.class_id == 1) {
      getSubjectByClass(body);
      getChapterBySubject(payload);
    }
    if (row?.class_id == 2 || row?.class_id == 3) {
      const body = {
        value: row?.class_id,
        label: row?.class_name,
      };
      handleClassChange(body);
      const payload = {
        value: row?.stream_id,
        label: row?.stream,
      };

      handleStreamChange(payload);

      const data = {
        label: row?.subject_name,
        value: row?.subject_id,
        class_id: row?.class_id,
        stream_id: row?.stream_id,
      };
      handleSubjectChange(data);
      setValue("chapter", {
        value: row?.chapter_id,
        label: row?.chapter_name,
      });
    }
  };
  const onFormSubmit = (data) => {
    var body = {};
    var options = [];
    var optionsT = [];
    if (importAI) {
      body = {
        class_id: data?.class?.label,
        ...(watch("class")?.value == "2" || watch("class")?.value == "3" ? { stream_id: watch("stream")?.label } : {}),
        subject_id: data?.subject?.label,
        chapter_id: data?.chapter?.label,
        quantity: parseInt(data?.quantity),
        question_type: data.question_type.value,
      }; 

      const enrichedQuestions = questionsList.map((q) => ({
        ...q,
        ...body,
      }));

      generateQuestionWithAIApi(body)
        .then((res) => {
          // const status = decrypt(res.data.status);
          const status = res.data.status;
          console.log("res from ai", res);
          if (status === true) {
            toast.success(res.data.message);
            toast.clearWaitingQueue();
          } else if (status === false) {
            setIsLoading(false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
          } else if (status === "expired") {
            setIsLoading(false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
            logout();
          }
        })
        .catch((err) => {
          setIsLoading(false);
          toast.error(err.message);
        });
      // ExportQuestion(enrichedQuestions);
      console.log("button clicked import with AI", data, body, enrichedQuestions);
      console.log("save import with AI", enrichedQuestions, textQ);
    } else if (importQ) {
      console.log("button clicked import questions", data);

      importQuestions();
      return;
    } else if (!importAI && !importQ) {
      console.log("button clicked normal question", data);
      options = [
        {
          option: data.option_one,
          isCorrect: data.correctOption === "option_one",
        },
        {
          option: data.option_two,
          isCorrect: data.correctOption === "option_two",
        },
        {
          option: data.option_three,
          isCorrect: data.correctOption === "option_three",
        },
        {
          option: data.option_four,
          isCorrect: data.correctOption === "option_four",
        },
      ];
      optionsT = [
        {
          option: data.option_one,
          isCorrect: data.correctOption === "option_one",
        },
        {
          option: data.option_two,
          isCorrect: data.correctOption === "option_two",
        },
      ];

      body = {
        ...(user?.role == "Subject Specialist" ? { class_id: user?.class_id } : { class_id: data?.class?.value }),
        ...(user?.role == "Subject Specialist"
          ? { stream_id: user?.stream_id }
          : { stream_id: watch("stream")?.value }),
        ...(user?.role == "Subject Specialist"
          ? { subject_id: user?.subject_id }
          : { subject_id: data?.subject?.value }),
        chapter_id: data?.chapter?.value,
        question: data.question,
        question_type: data.question_type.value,
        option: data?.question_type?.value == "true_false" ? optionsT : options,
        status:
          watch("status")?.value == "active"
            ? "active"
            : watch("status")?.value == "inactive"
              ? "inactive"
              : "inactive",
        ...(mode == "Edit" && { id: watch("id") }),
      };

      if (mode == "Add") {
        createQuestionAPI(body)
          .then((res) => {
            // const status = decrypt(res.data.status);
            const status = res.data.status;
            if (status) {
              toast.success(res.data.message);
              toast.clearWaitingQueue();
              getQuestion();
              setIsOpen(false);
              setIsLoading(false);
            } else if (!status) {
              setIsLoading(false);
              toast.error(res.data.message);
              toast.clearWaitingQueue();
            } else if (res.data.status == "expired") {
              setIsLoading(false);
              toast.error(res.data.message);
              toast.clearWaitingQueue();
              logout();
            }
          })
          .catch((err) => {
            setIsLoading(false);
            toast.error(err.message);
          });
      }
      if (mode == "Edit") {
        updateQuestionAPI(body)
          .then((res) => {
            // const status = decrypt(res.data.status);
            const status = res.data.status;
            if (status) {
              toast.success(res.data.message);
              toast.clearWaitingQueue();
              getQuestion();
              setIsOpen(false);
              setIsLoading(false);
            } else if (!status) {
              setIsLoading(false);
              toast.error(res.data.message);
              toast.clearWaitingQueue();
            } else if (res.data.status == "expired") {
              setIsLoading(false);
              toast.error(res.data.message);
              toast.clearWaitingQueue();
              logout();
            }
          })
          .catch((err) => {
            console.log("cat", err);

            setIsLoading(false);
            toast.error(err.message);
          });
      }
    }
  };
  const confirmStatusChange = () => {
    const updatedStatus = selectedRow.status === "active" ? "inactive" : "active";
    const formObject = {
      id: selectedRow.id,
      status: updatedStatus,
    };

    const encryptedData = encrypt(formObject);
    const encryptData = {
      zero: encryptedData,
    };
    updateQuestionStatusAPI(formObject)
      .then((res) => {
        // decrypt data
        // const status = decrypt(res.data.status);
        const status = res.data.status;
        if (status === true) {
          getQuestion();
          setShowModal(false);
          toast.success(res.data.message);
          toast.clearWaitingQueue();
        } else if (status === false) {
          toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (status === "expired") {
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => console.error("Error updating status:", err));
  };
  const handleQuestionDelete = (row) => {
    const body = {
      id: row?.id,
    };
    deleteQuestionAPI(body)
      .then((res) => {
        const status = res.data.status;
        if (status === true) {
          setIsLoading(false);
          setShowDelete(false);
          reset();
          getQuestion();
          toast.success(res.data.message);
        } else if (status === false) {
          setIsLoading(false);
          toast.warning(res.data.message);
        } else if (status === "expired") {
          toast.error(res.data.message);
          logout();
        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.log("error", err);
      });
  };
  const handleStreamChange = (selectedOption) => {
    setValue("stream", selectedOption || "");
    trigger("stream");
    if (watch("mode") == "Add") {
      setValue("subject", "");
      setValue("chapter", "");
    }
    const body = {
      class_id: watch("class")?.value,
      stream_id: watch("stream")?.value,
    };
    getSubjectByClass(body);
  };
  const getStreamByClass = (data) => {
    getStreamByClassDD(data)
      .then((res) => {
        // decrypt data
        const status = res.data.status;
        // const status = decrypt(res.data.status);
        if (status === "expired") {
          setValue("streamList", []);
          toast.error(res.data.message);
          logout();
        } else if (status) {
          toast.success(res.data.message);
          setValue("streamList", res.data.data);
          toast.clearWaitingQueue();
        } else {
          toast.warning(res.data.message);
          setValue("streamList", []);
          toast.clearWaitingQueue();
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };
  const handleChange = (e) => {
    const selectedFile = e.target.files[0];

    if (!selectedFile) {
      setValue("file", null);
      setError("file", { type: "manual", message: "File is required" });
      return;
    }

    validateExcelOrCsv(selectedFile, (isValid) => {
      if (isValid) {
        clearErrors("file");
        setValue("file", selectedFile);
      } else {
        setValue("file", null);
        setError("file", {
          type: "manual",
          message: "Invalid file type. Please upload a valid Excel/CSV file.",
        });
        toast.error("Invalid file type. Please upload a valid Excel/CSV file.");
        e.target.value = null;
      }
    });
  };
  const handleCancel = () => {
    setValue("file", null);
  };
  const handleSampleFileOpen = (name) => {
    // Replace 'sample_file.txt' with the name of your sample file
    const fileName = watch(name);
    var filePath;
    // Path to your sample file
    // if (selectedType?.value == "facility") {
    filePath = `${BASE_URL_IMG_LMS}${name}`; // Update the path
    // } else {
    //   filePath = `${base}${sampelFileV2}`; // Update the path
    // }
    const link = document.createElement("a");
    link.href = filePath;
    link.download = name;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  const importQuestions = () => {
    const formData = new FormData();
    formData.append("file", watch("file"));
    formData.append("question_type", watch("question_type")?.value);
    formData.append("chapter_id", watch("chapter")?.value);
    formData.append("class_id", watch("class")?.value);
    if (watch("class")?.value == "2" || watch("class")?.value == "3") {
      formData.append("stream_id", watch("stream")?.value);
    }
    formData.append("subject_id", watch("subject")?.value);

    bulkImportQuestionAPI(formData)
      .then((res) => {
        const status = res.data.status;
        if (status == "success") {
          toast.success(res.data.message);
        } else if (!status) {
          // toggleConfirmModal();
        } else if (status == "expired") {
          toast.error(res.data.message);
          logout();
        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.log("catch", err);
      });
  };
  return (
    <>
      <Head title={"Question | Master"} />
      <Content>
        {!isView ? (
          <div className="p-5" style={{}}>
            <p style={{ color: "crimson", textAlign: "center" }}>{"Unauthorized"}</p>
            <p style={{ textAlign: "center" }}>
              You will be redirected to the home page in <b style={{ color: "crimson" }}>{timer} </b> seconds.
            </p>
          </div>
        ) : (
          <>
            <BlockHead size={`sm`}>
              <BlockBetween>
                <BlockHeadContent>
                  <BlockTitle page tag="h3">
                    {!importAI && !importQ && (isOpen || !isOpen) && "Question"}
                    {importAI && (isOpen || !isOpen) && "Generate Question with AI"}
                    {importQ && (isOpen || !isOpen) && "Import Questions"}
                  </BlockTitle>
                </BlockHeadContent>
                {isCreate && (
                  <BlockHeadContent>
                    <div className="">
                      <Button
                        color="primary"
                        outline
                        className={`  me-1`}
                        onClick={() => {
                          setIsOpen(!isOpen);
                          setImportAI(true);
                          setImportQ(false);
                          reset();
                        }}
                      >
                        <Icon name={"reddit"} className={"mx-1"} /> Generate With AI
                      </Button>
                      <Button
                        color="primary"
                        outline
                        className={`  me-1`}
                        onClick={() => {
                          setIsOpen(!isOpen);
                          setImportQ(true);
                          setImportAI(false);
                          reset();
                        }}
                      >
                        <Icon name={"upload"} className={"mx-1"} /> Import Questions
                      </Button>
                      <Button
                        color="primary"
                        outline
                        className={`  me-1`}
                        onClick={() => {
                          setIsOpen(!isOpen);
                          setImportQ(false);
                          setImportAI(false);
                          setMode("Add");
                          setValue("mode", "Add");
                          reset();
                        }}
                      >
                        {<Icon name={isOpen ? "minus" : "plus"} />}
                      </Button>
                    </div>
                  </BlockHeadContent>
                )}
              </BlockBetween>
            </BlockHead>
            <Block>
              <Row className={`g-gs`}>
                {isOpen && (
                  <PreviewAltCard>
                    <Form onSubmit={handleSubmit(onFormSubmit)}>
                      <Row className={`g-gs`}>
                        {/* Class */}
                        {user?.role == "Subject Specialist" ? null : (
                          <Col md={`2`}>
                            <div className="form-group">
                              <Label className="from-label" htmlFor="class">
                                Class
                                <Required />
                              </Label>
                              <div className="form-control-wrap">
                                <Select
                                  className=""
                                  id="class"
                                  options={classList}
                                  {...register("class", {
                                    required: "Please select class",
                                  })}
                                  onChange={handleClassChange}
                                  value={watch("class")}
                                />
                                {errors.class && <span className="invalid">{errors?.class?.message}</span>}
                              </div>
                            </div>
                          </Col>
                        )}
                        {/* Stream */}
                        {user?.role == "Subject Specialist" ? null : (
                          <>
                            {" "}
                            {(watch("class")?.value == "2" || watch("class")?.value == "3") && (
                              <Col md={`2`}>
                                <div className="form-group">
                                  <Label className="from-label" htmlFor="stream">
                                    Stream
                                    <Required />
                                  </Label>
                                  <div className="form-control-wrap">
                                    <Select
                                      className=""
                                      id="stream"
                                      options={watch("streamList")}
                                      {...register("stream", {
                                        required: "Please select stream",
                                      })}
                                      onChange={handleStreamChange}
                                      value={watch("stream")}
                                    />
                                    {errors.stream && (
                                      <span
                                        className="invalid"
                                        style={{
                                          color: "#e85347",
                                          fontSize: "11px",
                                          fontStyle: "italic",
                                        }}
                                      >
                                        {errors?.stream?.message}
                                      </span>
                                    )}
                                  </div>
                                </div>
                              </Col>
                            )}
                          </>
                        )}
                        {/* Subject */}
                        {user?.role == "Subject Specialist" ? null : (
                          <Col md={`2`}>
                            <div className="form-group">
                              <Label className="from-label" htmlFor="subject">
                                Subject
                                <Required />
                              </Label>
                              <div className="form-control-wrap">
                                <Select
                                  className=""
                                  id="subject"
                                  options={subjectList}
                                  {...register("subject", {
                                    required: "Please select subject",
                                  })}
                                  onChange={handleSubjectChange}
                                  value={watch("subject")}
                                />
                                {errors.subject && <span className="invalid">{errors?.subject?.message}</span>}
                              </div>
                            </div>
                          </Col>
                        )}
                        {/* Chapter */}
                        <Col md={`4`}>
                          <div className="form-group">
                            <Label className="from-label" htmlFor="chapter">
                              Chapter
                              <Required />
                            </Label>
                            <div className="form-control-wrap">
                              <Select
                                className=""
                                id="chapter"
                                options={chapterList}
                                {...register("chapter", {
                                  required: "Please select chapter",
                                })}
                                onChange={handleChapterChange}
                                value={watch("chapter")}
                              />
                              {errors.chapter && <span className="invalid">{errors?.chapter?.message}</span>}
                            </div>
                          </div>
                        </Col>
                        {/* Question Type */}
                        <Col md={`2`}>
                          <div className="form-group">
                            <Label className="from-label" htmlFor="question_type">
                              Question Type
                              <Required />
                            </Label>
                            <div className="form-control-wrap">
                              <Select
                                className=""
                                id="question_type"
                                options={[
                                  // { value: "multiple_choice", label: "Multiple Choice" },
                                  { value: "single_choice", label: "Single Choice" },
                                  { value: "true_false", label: "True or False" },
                                ]}
                                {...register("question_type", {
                                  required: "Please select chapter",
                                })}
                                onChange={handleQuestionTypeChange}
                                value={watch("question_type")}
                              />
                              {errors.question_type && (
                                <span className="invalid">{errors?.question_type?.message}</span>
                              )}
                            </div>
                          </div>
                        </Col>
                        {importAI ? (
                          <>
                            {/* Quantity */}
                            <Col md="2" sm="3" xxl="2">
                              <div className="form-group">
                                <Label className="form-label" htmlFor="quantity">
                                  {"Quantity"}
                                  <Required />
                                </Label>
                                <div className="form-control-wrap">
                                  <input
                                    placeholder={"Enter quantity"}
                                    type="text"
                                    id="quantity"
                                    {...register("quantity", {
                                      required: "Quantity is required",
                                      pattern: {
                                        value: /^[1-9][0-9]{0,2}$/,
                                        message: "Enter a Quantity greater than 10 and up to 25",
                                      },
                                      minLength: {
                                        value: 1,
                                        message: "Quantity must be at least 10 characters long",
                                      },
                                      validate: (value) =>
                                        (value >= 10 && value <= 25) || "Quantity must be between 10 and 25",
                                    })}
                                    className="form-control"
                                    onChange={(e) => {
                                      e.target.value = e.target.value.replace(/[^0-9]/g, ""); // Remove non-numeric characters
                                      setValue("quantity", e.target.value);
                                      trigger("quantity"); // Trigger validation
                                    }}
                                    value={watch("quantity")}
                                  />
                                  {errors.quantity && <span className="invalid">{errors?.quantity?.message}</span>}
                                </div>
                              </div>
                            </Col>{" "}
                          </>
                        ) : null}
                        {importAI ? null : (
                          <>
                            {importQ ? (
                              <Col md="2">
                                {sampleFile1 != null && watch("question_type")?.value == "single_choice" && (
                                  <div className="mt-5 text-end">
                                    <label
                                      style={{
                                        fontSize: "9px",
                                        marginRight: "3px",
                                        color: "crimson",
                                        cursor: "default",
                                      }}
                                    >
                                      {"download sample file for single choice questions"}
                                    </label>
                                    <Button
                                      size="xs"
                                      id="upload-image-modal"
                                      className="mb-1"
                                      color="primary"
                                      type="button"
                                      outline
                                      onClick={() => handleSampleFileOpen(sampleFile1)}
                                    >
                                      <Icon name="download" style={{ cursor: "pointer" }}>
                                        <Tooltip
                                          placement="top"
                                          isOpen={toolImage}
                                          target="upload-image-modal"
                                          toggle={toggleImage}
                                        >
                                          download sample file format
                                        </Tooltip>{" "}
                                      </Icon>
                                    </Button>
                                  </div>
                                )}
                                {sampleFile2 != null && watch("question_type")?.value == "true_false" && (
                                  <div className="mt-5 text-end">
                                    <label
                                      style={{
                                        fontSize: "9px",
                                        marginRight: "3px",
                                        color: "crimson",
                                        cursor: "default",
                                      }}
                                    >
                                      {"download sample file for true or false questions"}
                                    </label>
                                    <Button
                                      size="xs"
                                      id="upload-image-modal"
                                      className="mb-1"
                                      color="primary"
                                      outline
                                      type="button"
                                      onClick={() => handleSampleFileOpen(sampleFile2)}
                                    >
                                      <Icon name="download" style={{ cursor: "pointer" }}>
                                        <Tooltip
                                          placement="top"
                                          isOpen={toolImage}
                                          target="upload-image-modal"
                                          toggle={toggleImage}
                                        >
                                          download sample file format
                                        </Tooltip>{" "}
                                      </Icon>
                                    </Button>
                                  </div>
                                )}
                              </Col>
                            ):null}
                          </>
                        )}
                        {/* Status */}
                        {!importQ && !importAI && (
                          <Col md={`2`}>
                            <Status
                              setValue={setValue}
                              trigger={trigger}
                              register={register}
                              watch={watch}
                              errors={errors}
                            />
                          </Col>
                        )}
                        {console.log("import --->",importAI,importQ,watch("question_type")?.value,watch("sampleFile1"),watch("sampleFile2"))}
                        {/* Question */}
                        {importAI ? null : (
                          <>
                            {!importQ ? (
                              <Col md="12" sm="12" xxl="12">
                                <div className="form-group">
                                  <Label className="form-label" htmlFor="question">
                                    {"Question"}
                                    <Required />
                                  </Label>

                                  <div className="form-control-wrap">
                                    <textarea
                                      placeholder={"Enter question"}
                                      type="text"
                                      id="question"
                                      {...register("question", {
                                        required: {
                                          value: true,
                                          message: "question is required",
                                        },
                                        // pattern: {
                                        //   value: /^(?!\s*$)[a-zA-Z /.]*$/,
                                        //   message: "Only alphabets are allowed",
                                        // },
                                        minLength: {
                                          value: 3,
                                          message: "question must be at least 2 characters long",
                                        },
                                        maxLength: {
                                          value: 500,
                                          message: "question cannot exceed 500 characters",
                                        },
                                      })}
                                      className="form-control"
                                      value={watch("question")}
                                      onChange={(e) => {
                                        // let value = e.target.value.replace(/[^A-Za-z\s]/g, ""); // Remove invalid characters
                                        // value = value.replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize each word
                                        setValue("question", e.target.value);
                                        trigger("question"); // Trigger validation
                                      }}
                                      // onInput={(e) => {
                                      //   e.target.value = e.target.value.replace(/[^A-Za-z\s]/g, "");
                                      // }}
                                    />
                                    {errors.question && <span className="invalid">{errors?.question?.message}</span>}
                                  </div>
                                </div>
                              </Col>
                            ):null}
                            {!importQ ? (
                              <>
                                {watch("question_type")?.value == "multiple_choice" && (
                                  <>
                                    {["option_one", "option_two", "option_three", "option_four"].map((opt, index) => (
                                      <React.Fragment key={opt}>
                                        <Col md="10 mt-2">
                                          <div className="form-group">
                                            <Label className="form-label" htmlFor={opt}>
                                              {`Option ${index + 1}`}
                                            </Label>
                                            <div className="form-control-wrap">
                                              <input
                                                placeholder={`Enter Option ${index + 1}`}
                                                type="text"
                                                id={opt}
                                                className="form-control"
                                                {...register(opt, {
                                                  required: `Option ${index + 1} is required`,
                                                  minLength: {
                                                    value: 1,
                                                    message: "Minimum 1 characters",
                                                  },
                                                  maxLength: {
                                                    value: 500,
                                                    message: "Maximum 500 characters",
                                                  },
                                                })}
                                                value={watch(opt)}
                                                onChange={(e) => {
                                                  setValue(opt, e.target.value);
                                                  trigger(opt);
                                                }}
                                              />
                                              {errors[opt] && <span className="invalid">{errors[opt].message}</span>}
                                            </div>
                                          </div>
                                        </Col>
                                        <Col md="2" className={`d-flex align-items-end`}>
                                          <div className="form-group">
                                            <input
                                              type="checkbox"
                                              value={opt}
                                              {...register("correctOption", {
                                                validate: (value) =>
                                                  value && value.length > 0
                                                    ? true
                                                    : "Please select at least one correct answer",
                                              })}
                                              className="custom-radio me-2"
                                            />
                                            <Label className="form-label" htmlFor={opt}>
                                              {`Correct Answer`}
                                            </Label>
                                          </div>
                                        </Col>
                                        {errors.correctOption && (
                                          <Col md="12">
                                            <span className="invalid">{errors.correctOption.message}</span>
                                          </Col>
                                        )}
                                      </React.Fragment>
                                    ))}
                                  </>
                                )}{" "}
                                {watch("question_type")?.value == "single_choice" && (
                                  <>
                                    {["option_one", "option_two", "option_three", "option_four"].map((opt, index) => (
                                      <React.Fragment key={opt}>
                                        <Col md="10 mt-2">
                                          <div className="form-group">
                                            <Label className="form-label" htmlFor={opt}>
                                              {`Option ${index + 1}`}
                                            </Label>
                                            <div className="form-control-wrap">
                                              <input
                                                placeholder={`Enter Option ${index + 1}`}
                                                type="text"
                                                id={opt}
                                                className="form-control"
                                                {...register(opt, {
                                                  required: `Option ${index + 1} is required`,
                                                  minLength: {
                                                    value: 1,
                                                    message: "Minimum 1 characters",
                                                  },
                                                  maxLength: {
                                                    value: 500,
                                                    message: "Maximum 500 characters",
                                                  },
                                                })}
                                                value={watch(opt)}
                                                onChange={(e) => {
                                                  setValue(opt, e.target.value);
                                                  trigger(opt);
                                                }}
                                              />
                                              {errors[opt] && <span className="invalid">{errors[opt].message}</span>}
                                            </div>
                                          </div>
                                        </Col>
                                        <Col md="2" className={`d-flex align-items-end`}>
                                          <div className="form-group">
                                            <input
                                              type="radio"
                                              name="correctOption"
                                              value={opt}
                                              {...register("correctOption", {
                                                required: "Please select the correct answer",
                                              })}
                                              className=" custom-radio me-2"
                                            />

                                            <Label className="form-label" htmlFor={opt}>
                                              {`Correct Answer`}
                                            </Label>
                                          </div>
                                        </Col>
                                        {errors.correctOption && (
                                          <Col md="12">
                                            <span className="invalid">{errors.correctOption.message}</span>
                                          </Col>
                                        )}
                                      </React.Fragment>
                                    ))}
                                  </>
                                )}{" "}
                                {watch("question_type")?.value == "true_false" && (
                                  <>
                                    {["option_one", "option_two"].map((opt, index) => (
                                      <React.Fragment key={opt}>
                                        <Col md="10 mt-2">
                                          <div className="form-group">
                                            <Label className="form-label" htmlFor={opt}>
                                              {`Option ${index + 1}`}
                                            </Label>
                                            <div className="form-control-wrap">
                                              <input
                                                placeholder={`Enter Option ${index + 1}`}
                                                type="text"
                                                id={opt}
                                                className="form-control"
                                                {...register(opt, {
                                                  required: `Option ${index + 1} is required`,
                                                  minLength: {
                                                    value: 1,
                                                    message: "Minimum 1 characters",
                                                  },
                                                  maxLength: {
                                                    value: 500,
                                                    message: "Maximum 500 characters",
                                                  },
                                                })}
                                                value={watch(opt)}
                                                onChange={(e) => {
                                                  setValue(opt, e.target.value);
                                                  trigger(opt);
                                                }}
                                              />
                                              {errors[opt] && <span className="invalid">{errors[opt].message}</span>}
                                            </div>
                                          </div>
                                        </Col>
                                        <Col md="2" className={`d-flex align-items-end`}>
                                          <div className="form-group">
                                            <input
                                              type="radio"
                                              name="correctOption"
                                              value={opt}
                                              {...register("correctOption", {
                                                required: "Please select the correct answer",
                                              })}
                                              className=" custom-radio me-2"
                                            />

                                            <Label className="form-label" htmlFor={opt}>
                                              {`Correct Answer`}
                                            </Label>
                                          </div>
                                        </Col>
                                        {errors.correctOption && (
                                          <Col md="12">
                                            <span className="invalid">{errors.correctOption.message}</span>
                                          </Col>
                                        )}
                                      </React.Fragment>
                                    ))}
                                  </>
                                )}
                              </>
                            ):null}
                            {importQ && (
                              <Col md="4" sm="3" xxl="3">
                                {watch("file") != null ? (
                                  <div className="col-md-12">
                                    <p
                                      style={{ whiteSpace: "pre-wrap", overflowWrap: "break-word", marginTop: "20px" }}
                                    >
                                      Selected File : {watch("file")?.name || ""}
                                    </p>

                                    <Button color="danger" size="sm" onClick={handleCancel}>
                                      Cancel
                                    </Button>
                                  </div>
                                ) : (
                                  <div className="form-group">
                                    <label className="form-label">
                                      {"Choose file"}
                                      <Required />
                                    </label>
                                    <input
                                      type="file"
                                      id="fileInput"
                                      className={`form-control  `}
                                      {...register("file", { required: "File is required" })}
                                      onChange={handleChange}
                                    />
                                    {errors.file && <span className="invalid">{errors.file.message}</span>}
                                  </div>
                                )}
                              </Col>
                            )}
                          </>
                        )}
                      </Row>

                      {importAI ? (
                        <Col md="2" className={``}>
                          <div className="form-group" style={{ marginTop: "31px" }}>
                            <Button disabled={isLoading} color="primary" size="md">
                              {isLoading ? <Spinner size="sm" color="light" /> : "Generate"}
                            </Button>
                          </div>
                        </Col>
                      ) : (
                        <Col md="2" className={``}>
                          <MyButton isLoading={isLoading} mode={mode} />
                        </Col>
                      )}
                    </Form>
                  </PreviewAltCard>
                )}
                <MyDataTable data={data} columns={columns} title={"Question"} isLoading={isLoading} />
              </Row>
            </Block>
          </>
        )}
      </Content>

      {/* Confirmation Modal */}
      <ConfirmModal
        isOpen={showModal}
        toggle={() => setShowModal(!showModal)}
        onConfirm={confirmStatusChange}
        status={selectedRow?.status}
      />

      <DeleteModal
        loading={isLoading}
        name={watch("deleteQuestion")}
        deleteModal={showDelete}
        rowData={watch("deleteRow")}
        toggleDeleteModal={() => setShowDelete(!showDelete)}
        deleteRow={(e) => handleQuestionDelete(e)}
      />
      {/* AI Generated Questions */}
      <QuestionModal isOpen={qModal} toggle={toggleQModal} questionsList={questionsList} question_type={"true_false"} />
    </>
  );
};

export default Question;
